import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleGetService } from '../../services';

export const fetchModuleGet = createAsyncThunk(
    'moduleGet/fetchModuleGet',
    async ({ id }) => {
        const response = await ModuleGetService(id)
        return response.result
    }
);

const moduleGetSlice = createSlice({
    name: 'moduleGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleGetSlice.reducer;
